export default __webpack_public_path__ + "static/artem-0f862294693d71006439fe13e70face7.jpg";